import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import BatchProcessor from '../../components/Batch.vue';
export default {
  __name: 'BatchPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "批量图片处理",
        "current-page": "batch"
      }, {
        default: _withCtx(() => [_createVNode(BatchProcessor)]),
        _: 1
      });
    };
  }
};